module.exports = __webpack_public_path__ + "img/BK.98172c48.png";